import { Injectable, signal } from '@angular/core';
import { MenuStatus } from './header';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  public isMenuOpen = signal<MenuStatus>({ notification: false, seguradoras: false });

  constructor() { }

}
